import { withTranslation } from "next-i18next";
import { useState } from "react";
import { useRouter } from "next/compat/router";
import MenuListButton from "@components/core/MenuListButton";
import { useDislikeProduct } from "@hooks/use-current-user";
import { deleteProductFromUserList } from "@utils/call-api/userlists-call";

function MenuUserListProductEdit({ product, onActionEnd, t }) {
  const router = useRouter();
  const dislikeProduct = useDislikeProduct();

  const [processingRemoveFromUserList, setProcessingRemoveFromUserList] = useState(false);
  const [processingDislike, setProcessingDislike] = useState(false);

  async function removeFromUserListAndClose() {
    try {
      setProcessingRemoveFromUserList(true);
      const userListUuid = router.query.uuid;

      await deleteProductFromUserList(userListUuid, product.id);
      onActionEnd();
    } catch (err) {
      onActionEnd();
    }
  }

  async function dislikeAndClose() {
    try {
      setProcessingDislike(true);
      await dislikeProduct(product.id);
      onActionEnd();
    } catch (err) {
      onActionEnd();
    }
  }

  return (
    <div className="d-flex flex-column w-100">
      <MenuListButton
        onClick={removeFromUserListAndClose}
        trackingName="RemoveFromUserlistFromOffcanvas"
        loading={processingRemoveFromUserList}
      >
        {t("common:userlist.remove_from_userlist")}
      </MenuListButton>
      <MenuListButton
        onClick={dislikeAndClose}
        trackingName="RemoveFromWishlistFromOffcanvas"
        loading={processingDislike}
      >
        {t("common:userlist.remove_from_wishlist")}
      </MenuListButton>
    </div>
  );
}

export default withTranslation("common")(MenuUserListProductEdit);
